// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsHoldingsAllHoldingsModule } from './app.module';
bootstrapAppModule(MutualFundsHoldingsAllHoldingsModule);
